import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { login, loadUser } from "../Dashboard/actions/auth";
import InfoAlert from "../Dashboard/components/Modals/InfoAlert";
import logoSplashScreen from "../images/logoSplashScreen.jpg";
import "./Login.css";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      EST {" © "} Energy Center -{" "}
      <a href="https://www.polito.it/" style={{ color: "gray" }}>
        Politecnico di Torino
      </a>{" "}
      &nbsp;
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export class Login extends Component {
  state = {
    username: "",
    password: "",
  };

  onChange = (e) => this.setState({ [e.target.name]: e.target.value });

  onSubmit = (e) => {
    e.preventDefault();
    this.props.login(this.state.username, this.state.password);
  };

  render() {
    if (this.props.isAuthenticated) {
      return <Redirect to="/dashboard/maps/mymap"></Redirect>;
    } else {
      this.props.loadUser();
    }
    return (
      <div
        style={{
          // border: "3px solid #3ec762",
          width: "800px",
          paddingBottom: "20px",
          margin: "20px auto",
        }}
      >
        <React.Fragment>
          <img
            src={logoSplashScreen}
            alt="logo"
            style={{
              maxWidth: "45%",
              height: "auto",
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
              marginTop: "30px",
              width: "45%",
              marginBottom: "0px",
            }}
          ></img>
          <div className="splashscreen">
            <h1>EST</h1>
            <h1>RES</h1>
          </div>
        </React.Fragment>
        <Container
          component="main"
          maxWidth="xs"
          style={{
            paddingTop: "0px",
          }}
        >
          {/* <CssBaseline /> */}

          <div style={{ marginLeft: "25px" }}>
            <form noValidate onSubmit={this.onSubmit}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="username"
                label="Username"
                name="username"
                autoComplete="username"
                autoFocus
                onChange={this.onChange}
                value={this.state.username}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                onChange={this.onChange}
                value={this.state.password}
              />
              <Button
                fullWidth
                variant="contained"
                style={{
                  marginBottom: "15px",
                  marginTop: "30px",
                  backgroundColor: "#3A5CDB",
                  color: "white",
                }}
                type="submit"
              >
                Login
              </Button>
              <Grid container>
                <Grid item xs>
                  <p
                    onClick={() =>
                      InfoAlert(
                        "Contact the Administrator to get the password."
                      )
                    }
                    style={{ color: "#1E48BB", cursor: "pointer" }}
                  >
                    Forgot password?
                  </p>
                </Grid>
                <Grid item>
                  <p
                    onClick={() =>
                      InfoAlert("Contact the Administrator to get an account.")
                    }
                    style={{ color: "#1E48BB", cursor: "pointer" }}
                  >
                    {" "}
                    Need an account?
                  </p>
                </Grid>
              </Grid>
            </form>
          </div>
          <Box mt={3} ml={2} style={{ width: "400px" }}>
            <Copyright />
          </Box>
          <Box mt={1} style={{ textAlign: "center", marginRight: "-35px" }}>
            <Typography variant="body2" color="textSecondary" align="center">
              In cooperation with{" "}
              <a href="https://www.gdpanalytics.com" style={{ color: "gray" }}>
                GDP Analytics
              </a>
            </Typography>
          </Box>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  isStaff: state.auth.isStaff,
});

export default connect(mapStateToProps, {
  login,
  loadUser,
})(Login);
